export const ROUTES = {
  HOME: '/',
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  RECOVER_PASSWORD: '/recover-password',
  COMPLETE_PROFILE: '/complete-profile',
  PROFILE: '/profile',
  LEAGUE: '/league',
  CLAN_ARENA: '/clan-arena',
  MY_COLLECTIONS: '/my-collections',
  CLAN: '/clan',
  WINNING_HISTORY: '/winning-history',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
